import { get } from 'axios'
// import store from '@/store'
import store from './../../store/index.js'

const BASE_URL = store.state.api.baseUrl
const headers = { Authorization: `Bearer ${store.state.user.attributes.token}` }

function getPostulantContractPayments (pPage, pIdProgramSeasonPostulant) {
    const URI = `${BASE_URL}/api/programSeasonPostulants/${pIdProgramSeasonPostulant}/contractPayments?page=${pPage}`
    return get(URI, { headers })
}
export { getPostulantContractPayments }